module.exports = {
  api: {
    url: process.env.VUE_APP_API_URL,
  },
  bo: {
    token: process.env.VUE_APP_BO_ACCESS_TOKEN,
  },
  jumio: {
    successUrl: process.env.VUE_APP_JUMIO_SUCCESS_URL,
    errorUrl: process.env.VUE_APP_JUMIO_ERROR_URL,
  }
}